import { render, staticRenderFns } from "./editWechat.vue?vue&type=template&id=5870ff4c&scoped=true&"
import script from "./editWechat.vue?vue&type=script&lang=js&"
export * from "./editWechat.vue?vue&type=script&lang=js&"
import style0 from "./editWechat.vue?vue&type=style&index=0&id=5870ff4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870ff4c",
  null
  
)

export default component.exports